import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-pages" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, " Versão " + _toDisplayString(_ctx.version) + " - © " + _toDisplayString(_ctx.currentYear) + " Digitaldoc. Todos os direitos reservados. ", 1))
}